import { changeQuery } from '@/libs/url';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PagePathV2 } from '@features/types';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import { getImgSrc } from '@/utils/utils';
import {
  reportLearnMoreClickEvent,
  reportModuleContentClickEvent,
} from './index.Report';

export const useModuleContainer = (
  articleList?: LearningInfo[],
  title?: string,
) => {
  const validArticleList = articleList?.filter(
    article => Number(article.learning_id) !== 0,
  );
  const [curHoverArticle, setCurHoverArticle] = useState<number>(0);
  const history = useHistory();
  const [imgSrc, setImgSrc] = useState<string>();

  const jumpToCourse = (learningId: number | undefined, index: number) => {
    reportModuleContentClickEvent(title, String(learningId), String(index));
    if (learningId) {
      history.push({
        pathname: PagePathV2.CourseDetail,
        search: changeQuery({
          learning_id: String(learningId),
          from: 'modules',
        }),
      });
    }
  };

  const jumpToModuleLandingPage = moduleId => {
    reportLearnMoreClickEvent(title);
    history.push({
      pathname: PagePathV2.ModuleLandingPage,
      search: changeQuery({
        config_id: moduleId,
        from: 'modules',
      }),
    });
  };

  useEffect(() => {
    const urlImg = validArticleList?.[curHoverArticle]?.image ?? '';
    getImgSrc(urlImg)
      .then(res => setImgSrc(res as string))
      .catch(err => setImgSrc(err));
  }, [curHoverArticle]);

  return {
    imgSrc,
    curHoverArticle,
    validArticleList,
    setCurHoverArticle,
    jumpToCourse,
    reportModuleContentClickEvent,
    jumpToModuleLandingPage,
  };
};
